import { useCustomerDetailQuery } from "./use-customer-detail-query";

interface UseCustomerDetailOptions {
  customerId: string;
}

export const useCustomerDetail = ({ customerId }: UseCustomerDetailOptions) => {
  const { customer, loading, error, retry } = useCustomerDetailQuery({ customerId });

  return {
    customer,
    loading,
    error,
    retry,
  };
};
